import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
var _ref = {
  name: "f2emof",
  styles: "display:block;position:relative;width:100%;height:100%;min-height:200px;"
};
var _ref2 = {
  name: "1cddlwo",
  styles: "-webkit-transform:translate3d(0,0,0);"
};
export var body = _ref5 => {
  var hackOverlay = _ref5.hackOverlay,
    fitContent = _ref5.fitContent,
    allowOverflow = _ref5.allowOverflow;
  return /*#__PURE__*/css(fitContent ? /*#__PURE__*/css("display:flex;overflow-y:", allowOverflow ? 'visible' : 'auto', ";") : _ref, " ", media('<desktop'), "{@media not all and (min-resolution:0.001dpcm){@media{", hackOverlay && _ref2, "}}}");
};
var _ref3 = {
  name: "k008qs",
  styles: "display:flex;"
};
var _ref4 = {
  name: "ci7hnp",
  styles: "width:100%;height:100%;top:0;bottom:0;overflow-y:auto;overflow-x:hidden;"
};
export var scrollContainer = _ref6 => {
  var enableScroll = _ref6.enableScroll,
    fitContent = _ref6.fitContent;
  return /*#__PURE__*/css(fitContent ? _ref3 : enableScroll && _ref4);
};